import { call, put, takeLatest } from 'redux-saga/effects';
import { DutiesApi } from 'lib/Api/duties';
import { FETCH_DUTY_REQUIREMENTS_REQUEST, FETCH_DUTY_REQUIREMENTS_FAILURE, FETCH_DUTY_REQUIREMENTS_SUCCESS } from './actions';
import { SagaIterator } from 'redux-saga';

type FetchDutyRequirementsAction = {
  type: typeof FETCH_DUTY_REQUIREMENTS_REQUEST;
  payload: { siteId: string };
};

function* fetchDutyRequirementsSaga(action: FetchDutyRequirementsAction): SagaIterator {
  try {
    const { siteId } = action.payload;
    const response = yield call(DutiesApi.getRequirements, siteId);
    
    if (response.error) {
      yield put({
        type: FETCH_DUTY_REQUIREMENTS_FAILURE,
        payload: { error: response.error.message },
      });
    } else {
      yield put({
        type: FETCH_DUTY_REQUIREMENTS_SUCCESS,
        payload: { siteId, requirements: response.data },
      });
    }
  } catch (error) {
    yield put({
      type: FETCH_DUTY_REQUIREMENTS_FAILURE,
      payload: { 
        error: error instanceof Error ? error.message : 'Unknown error occurred' 
      },
    });
  }
}

export function* watchDutyRequirements(): SagaIterator {
  yield takeLatest(FETCH_DUTY_REQUIREMENTS_REQUEST, fetchDutyRequirementsSaga);
}